import DriverTags from "../../../views/DriverTags";
import DriverTagsMapping from "../../../views/DriverTagsMapping";
import DriverTagsMappingAccounting from "../../../views/DriverTagsMappingAccounting";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const DriverTagsRoutes = [
  {
    path: "/driver-tags",
    component: DriverTags,
    exact: true,
    menuName: MenuNames.DRIVER_TAG,
  },
  {
    path: "/driver-tags-mappings-other",
    component: DriverTagsMapping,
    exact: true,
    menuName: MenuNames.DRIVER_TAG,
  },
  {
    path: "/driver-tags-mappings-accounting",
    component: DriverTagsMappingAccounting,
    exact: true,
    menuName: MenuNames.DRIVER_TAG,
  },
];

export default DriverTagsRoutes;
